import request from "@/service";

//短视频分类分页列表
export function getPage(params) {
  return request({
    url: `/resource/short/category/page`,
    method: "get",
    params
  });
}

/* 删除分类 */
export function deleteCategory(params) {
  return request({
    url: `/resource/short/category/delete`,
    method: "delete",
    data: params
  });
}

/* 新增分类 */
export function save(params) {
  return request({
    url: `/resource/short/category/save`,
    method: "post",
    data: params
  });
}

/* 更新分类 */
export function update(params) {
  return request({
    url: `/resource/short/category/update`,
    method: "put",
    data: params
  });
}

/* 分类详情 */
export function getInfo(uuid) {
  return request({
    url: `/resource/short/category/info/${uuid}`,
    method: "get"
  });
}

// 拖拽排序
export function updateOrderByDrag(data) {
  return request({
    url: `/resource/short/category/updateOrderByDrag`,
    method: "put",
    data
  });
}

// 上下线
export function online(data) {
  return request({
    url: `/resource/short/category/online`,
    method: "put",
    data
  });
}

//短视频分类列表
export function categoryList() {
  return request({
    url: `/resource/short/category/list`,
    method: "get"
  });
}
